/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Footer_Trial_CnaInputs */

const en_onboarding_paywall_footer_trial_cna = /** @type {(inputs: Onboarding_Paywall_Footer_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trial is completely free and will NOT auto-renew when it ends.`)
};

const ar_onboarding_paywall_footer_trial_cna = /** @type {(inputs: Onboarding_Paywall_Footer_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trial is completely free and will NOT auto-renew when it ends.`)
};

const de_onboarding_paywall_footer_trial_cna = /** @type {(inputs: Onboarding_Paywall_Footer_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trial is completely free and will NOT auto-renew when it ends.`)
};

const es_onboarding_paywall_footer_trial_cna = /** @type {(inputs: Onboarding_Paywall_Footer_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trial is completely free and will NOT auto-renew when it ends.`)
};

const fr_onboarding_paywall_footer_trial_cna = /** @type {(inputs: Onboarding_Paywall_Footer_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trial is completely free and will NOT auto-renew when it ends.`)
};

const it_onboarding_paywall_footer_trial_cna = /** @type {(inputs: Onboarding_Paywall_Footer_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trial is completely free and will not auto-renew when it ends.The trial is completely free and will NOT auto-renew when it ends.`)
};

const ja_onboarding_paywall_footer_trial_cna = /** @type {(inputs: Onboarding_Paywall_Footer_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trial is completely free and will NOT auto-renew when it ends.`)
};

const ko_onboarding_paywall_footer_trial_cna = /** @type {(inputs: Onboarding_Paywall_Footer_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trial is completely free and will NOT auto-renew when it ends.`)
};

const pt_br_onboarding_paywall_footer_trial_cna = /** @type {(inputs: Onboarding_Paywall_Footer_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trial is completely free and will NOT auto-renew when it ends.`)
};

const ru_onboarding_paywall_footer_trial_cna = /** @type {(inputs: Onboarding_Paywall_Footer_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trial is completely free and will NOT auto-renew when it ends.`)
};

const th_onboarding_paywall_footer_trial_cna = /** @type {(inputs: Onboarding_Paywall_Footer_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trial is completely free and will NOT auto-renew when it ends.`)
};

const tr_onboarding_paywall_footer_trial_cna = /** @type {(inputs: Onboarding_Paywall_Footer_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trial is completely free and will NOT auto-renew when it ends.`)
};

const zh_cn_onboarding_paywall_footer_trial_cna = /** @type {(inputs: Onboarding_Paywall_Footer_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体验完全免费，体验结束后也不会自动续费。`)
};

const zh_tw_onboarding_paywall_footer_trial_cna = /** @type {(inputs: Onboarding_Paywall_Footer_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体验完全免费，体验结束后也不会自动续费。`)
};

/**
* | output |
* | --- |
* | "The trial is completely free and will NOT auto-renew when it ends." |
*
* @param {Onboarding_Paywall_Footer_Trial_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_footer_trial_cna = /** @type {((inputs?: Onboarding_Paywall_Footer_Trial_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Footer_Trial_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_footer_trial_cna(inputs)
	if (locale === "ar") return ar_onboarding_paywall_footer_trial_cna(inputs)
	if (locale === "de") return de_onboarding_paywall_footer_trial_cna(inputs)
	if (locale === "es") return es_onboarding_paywall_footer_trial_cna(inputs)
	if (locale === "fr") return fr_onboarding_paywall_footer_trial_cna(inputs)
	if (locale === "it") return it_onboarding_paywall_footer_trial_cna(inputs)
	if (locale === "ja") return ja_onboarding_paywall_footer_trial_cna(inputs)
	if (locale === "ko") return ko_onboarding_paywall_footer_trial_cna(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_footer_trial_cna(inputs)
	if (locale === "ru") return ru_onboarding_paywall_footer_trial_cna(inputs)
	if (locale === "th") return th_onboarding_paywall_footer_trial_cna(inputs)
	if (locale === "tr") return tr_onboarding_paywall_footer_trial_cna(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_footer_trial_cna(inputs)
	return zh_tw_onboarding_paywall_footer_trial_cna(inputs)
});